module.exports = __webpack_public_path__ + "img/3.d1ccb420.png";